import React from 'react';
import { useParams } from 'react-router-dom';
import CourseDataProvider from '../../Utils/Courses/CourseDataProvider';
import {
  BreadcrumbContainer,
  SingleCourseContainer,
  SingleCardContainer,
  SingleCourseImage,
  SingleCourseInfo,
  SingleTop,
} from './EachCourse.styles';
import BreadCrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import PurchaseCourseButton from './PurchaseCourseButton.component';
import CourseDescription from './CourseDescription.component';
import LoadingOnlineTraining from '../../Components/LoadingPages/LoadingOnlineTraining.component';
import RecommendedCourses from './RecommendedCourses.component';

const SingleCourse = () => {
  const { id } = useParams();

  return (
    <>
      <SingleCourseContainer>
        <CourseDataProvider
          courseId={id}
          loadingComponent={LoadingOnlineTraining}
        >
          {(course) => (
            <>
              <HelmetHelper
                title={course?.courseName ? `${course?.courseName}` : 'Course '}
                description="Course Details"
              />
              <BreadcrumbContainer>
                <BreadCrumbs
                  one="Online Courses"
                  oneLink="/online"
                  two={course?.courseName}
                />
              </BreadcrumbContainer>
              <SingleCardContainer>
                <SingleTop>
                  <SingleCourseImage>
                    <img src={course?.image} alt="course" />
                  </SingleCourseImage>
                  <SingleCourseInfo>
                    <CourseDescription course={course} />
                    <PurchaseCourseButton id={id} />
                  </SingleCourseInfo>
                </SingleTop>
              </SingleCardContainer>
              <RecommendedCourses course={course} />
            </>
          )}
        </CourseDataProvider>
      </SingleCourseContainer>
    </>
  );
};

export default SingleCourse;
